import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LibraryScheduledClassesState {
    isLoading: boolean;
    data: any;
    error: any;
}

const initialState: LibraryScheduledClassesState = {
    isLoading: false,
    data: [],
    error: null,
};

const LibraryScheduledClassesSlice = createSlice({
    name: "LibraryScheduledClasses",
    initialState,
    reducers: {
        getLibraryScheduledClassesAction: (state) => {
            state.isLoading = true;
        },
        successGetLibraryScheduledClasses: (state, action: PayloadAction<any>) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        failureGetLibraryScheduledClasses: (state, action: PayloadAction<any>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});

export const {
    getLibraryScheduledClassesAction,
    successGetLibraryScheduledClasses,
    failureGetLibraryScheduledClasses,
} = LibraryScheduledClassesSlice.actions;

export default LibraryScheduledClassesSlice.reducer;
